module.exports = __webpack_public_path__ + "media/9_6.d3e1a297.wav";